import { isExternalLink } from '../../../../react-components/quick-links/state/helpers';

export const getExternalLinks = (
  links: Array<HTMLLinkElement>,
): Array<HTMLLinkElement> => {
  return links.filter(link => isExternalLink(link.getAttribute('href') || ''));
};

export const setDescriptiveAriaLabels = (
  links: Array<HTMLLinkElement>,
): Array<HTMLLinkElement> => {
  links.forEach(link => {
    link.setAttribute(
      'aria-label',
      polyglot.t('employee_assistance.external_links.warning_aria', {
        title: link.innerText,
      }),
    );
  });

  return links;
};

export const isAbsoluteUrl = (urlString: string) => {
  return urlString.indexOf('http') === 0;
};
